
<h2 class="text-xl font-semibold mt-2 mb-1">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.KOMMENTAR.TITEL' | translate }}</h2>
<form class="flex flex-col w-full" [formGroup]="form" cdkTrapFocus cdkTrapFocusAutoCapture>
  <label class="mb-2">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.KOMMENTAR.SUB_TITEL' | translate }}</label>
  <soft-multiline-input formControlName="kommentar" cdkFocusInitial></soft-multiline-input>
</form>

<div class="flex flex-row w-full gap-2">
  <button class="soft-button secondary w-1/2 mt-2 h-14" (click)="close(null)">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.SCHLIESSEN' | translate }}</button>
  <button class="soft-button primary w-1/2 mt-2 h-14" (click)="saveKommentar()">{{ '#WWS_BASISARTIKELSTAND.DIALOGE.ABSENDEN' | translate }}</button>
</div>